module.exports = __webpack_public_path__ + "img/rombo.4ea867b3.png";